import React, { useEffect, useState } from "react";
import AOS from "aos";
import Swal from "sweetalert2";
import emailjs from "@emailjs/browser";
import "./Contact.css";
// import "aos/dist/aos.css";

function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const serviceID = "service_syaylf5";
    const templateID = "template_5sytsak";
    const publicKey = "tVVpjOgRLVbUyu5w3";

    const templateParams = {
      from_name: formData.name,
      from_email: formData.email,
      phone: formData.phone,
      message: formData.message,
    };

    emailjs.send(serviceID, templateID, templateParams, publicKey)
      .then(() => {
        Swal.fire({
          icon: "success",
          title: "Message Sent!",
          text: "Thank you for contacting us. We’ll get back to you shortly.",
          confirmButtonColor: "#e74c3c",
        });
        setFormData({ name: "", email: "", phone: "", message: "" });
      })
      .catch((error) => {
        console.error("Email error:", error);
        Swal.fire({
          icon: "error",
          title: "Oops!",
          text: "Something went wrong. Please try again later.",
          confirmButtonColor: "#e74c3c",
        });
      });
  };

  return (
    <div className="contact-wrapper" id="contact">
      <div className="contact-container" data-aos="fade-up">
        <h2 className="contact-title">Get in Touch</h2>
        <p className="contact-subtitle">
          We'd love to hear from you. Simply fill out the form below and our team will reach out to you shortly.
        </p>

        <form className="contact-form" onSubmit={handleSubmit}>
          <input
            type="text"
            name="name"
            placeholder="Your Name"
            value={formData.name}
            onChange={handleChange}
            required
            data-aos="fade-right"
          />
          <input
            type="email"
            name="email"
            placeholder="Your Email"
            value={formData.email}
            onChange={handleChange}
            required
            data-aos="fade-left"
          />
          <input
            type="tel"
            name="phone"
            placeholder="Phone Number"
            value={formData.phone}
            onChange={handleChange}
            required
            data-aos="fade-right"
          />
          <textarea
            name="message"
            placeholder="Your Message"
            rows="5"
            value={formData.message}
            onChange={handleChange}
            required
            data-aos="fade-left"
          ></textarea>
          <button type="submit" data-aos="zoom-in">
            Send Message
          </button>
        </form>
      </div>

      {/* Google Map */}
      <div className="map-container" data-aos="fade-up">
        <iframe
          title="Redwolf Location"
          src="https://maps.google.com/maps?q=Redwolf%20Infotech&t=&z=13&ie=UTF8&iwloc=&output=embed"
          width="100%"
          height="350"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
        ></iframe>
      </div>
    </div>
  );
}

export default Contact;





